<script setup lang="ts">
import ArrowDownSvg from '@/assets/svg/icn_arrow_down.svg?component';
import {ref} from 'vue';
import {useRouter} from 'vue-router';
import {storeToRefs} from 'pinia';
import useUserStore from '@/store/user-store';

const router = useRouter();
const user = useUserStore();
const {myInfo} = storeToRefs(user);

const goToMyPage = () => router.push({name: 'UserInfo'});
const logOut = () => {
    window.customConfirm(
        {
            title: '',
            message: '로그아웃 하시겠습니까?',
            acceptBtnName: '로그아웃',
            denyBtnName: '취소',
        },
        async () => {
            await user.logout();
            router.push({name: 'Login'});
        },
    );
};

const isOpenDropdown = ref(false);
const toggleDropdown = () => {
    isOpenDropdown.value = !isOpenDropdown.value;
};
</script>

<template>
    <nav class="navbar-wrap">
        <router-link to="/" class="navbar-brand"
            ><img src="@/assets/image/b2b_logo.png" alt="여기어때 비즈니스" />
        </router-link>
        <div v-if="myInfo" class="navbar-my-info">
            <div class="info__name" @click="toggleDropdown">
                {{ myInfo.companyName }}<ArrowDownSvg />
            </div>
            <transition>
                <div
                    v-if="isOpenDropdown"
                    class="info__dropdown-backdrop"
                    @click="toggleDropdown"
                >
                    <ul class="info__dropdown">
                        <li class="item-button" @click="goToMyPage">내정보</li>
                        <li class="item-button" @click="logOut">로그아웃</li>
                    </ul>
                </div>
            </transition>
        </div>
        <div v-else class="navbar-my-info">회원가입</div>
    </nav>
</template>

<style lang="scss" scoped>
* {
    font-size: 14px;
    list-style: none;
    margin: 0;
    padding: 0;
    color: #49617a;
}
.navbar-wrap {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 100;
    width: 100%;
    height: 56px;
    background-color: white;
    box-shadow: 0 2px 8px rgb(0 0 0 / 5%);

    .navbar-brand {
        margin-left: 24px;
        display: flex;
        width: 156px;
        height: 16px;
        text-indent: -9999px;
        cursor: pointer;
    }

    .navbar-my-info {
        margin-right: 24px;
        font-weight: bold;

        .info__name {
            display: flex;
            align-items: center;
            cursor: pointer;

            svg {
                margin-left: 10px;
                fill: #49617a;
            }
        }

        .info__dropdown-backdrop {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;

            .info__dropdown {
                position: absolute;
                top: 50px;
                right: 16px;
                word-break: break-all;
                border-radius: 6px;
                background-color: $white;
                box-shadow: 0 1px 5px 0 rgb(0 0 0 / 13%);
                transition: 0.3s;
                cursor: pointer;

                .item-button {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 120px;
                    height: 46px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.04);

                    cursor: pointer;
                    transition: 0.3s;

                    &:hover {
                        background: #f2f5f9;
                    }
                }
            }
        }
    }
}

.v-enter-active,
.v-leave-active {
    transition: all 0.3s ease;
}

.v-enter-from,
.v-leave-to {
    transform: translateY(20px);
    opacity: 0;
}
</style>
